var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35345 12.3333H0.666992L3.4963 3.66663H5.44839L8.26534 12.3333H6.49239L5.8314 10.1047H3.01445L2.35345 12.3333ZM4.46617 5.32377H4.39204L3.36039 8.82853H5.49781L4.46617 5.32377Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89051 12.3333V3.66663H12.4117C13.9128 3.66663 14.9012 4.47298 14.9012 5.79996C14.9012 6.85393 14.2897 7.48885 13.4557 7.69837V7.77456C14.4688 7.87615 15.3337 8.58726 15.3337 9.88885C15.3337 11.4381 14.1105 12.3333 12.3993 12.3333H8.89051ZM10.5461 4.95551V7.27297H11.6457C12.7638 7.27297 13.258 6.84758 13.258 6.09202C13.258 5.38726 12.8071 4.95551 12.0225 4.95551H10.5461ZM10.5461 8.46663V11.0444H11.7878C13.0974 11.0444 13.6348 10.6127 13.6348 9.78726C13.6348 8.96821 13.1098 8.46663 12.1275 8.46663H10.5461Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperCaseIcon);
export default __webpack_public_path__ + "static/media/upperCaseIcon.237eb227ecba7f557f902de50222c19f.svg";
export { ForwardRef as ReactComponent };